<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center"
    content-class="relative flex flex-col w-3/4 h-3/4 mx-auto bg-white border rounded-lg"
  >
    <div class="p-6">
      <div class="pb-4 text-xl">{{title}}</div>

      <div class="info" v-for="(value, name, id) in data.fields" :key="id">
        <div class="bold">{{ prettyName(name) }}:</div>
        <div class="value">{{ value }}</div>
      </div>

      <button class="pad btn btn-primary float-right" @click="closeModal()">Close</button>

      <div class="h-10">&nbsp;</div>
    </div>
  </VueFinalModal>
</template>

<script setup>
  import { VueFinalModal } from 'vue-final-modal'
  import { onMounted, ref } from 'vue'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  let title = ref(props.params.data.title)
  let data = ref(null)

  onMounted(() => {
    data.value = {
      fields: props.params.data.fields
    }
  })


  function closeModal() {
    emit('close')
  }

  function prettyName(str) {
    var rString = str.replace(/_/g,' ')
    return rString.replace(/\b[a-zA-Z]/g, (match) => match.toUpperCase())
  }
</script>

<style>
  .vm--modal {
    overflow: initial !important;
  }
  .info {
    padding: 10px;
    display: flex;
    flex-direction: row;
  }
  .bold {
    font-weight: bold;
  }
  .value {
    padding-left: 5px;
  }
</style>
